import { useRef, useState } from 'react'
import { Play, Pause, Volume2, VolumeX } from 'lucide-react'
import videoTruviq from "../../assets/truviq.mp4"
export default function HeroVideo({
  src = {videoTruviq},
  poster = '/video-poster.jpg',
}) {
 const videoRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [progress, setProgress] = useState(0)
  const togglePlay = () => {
    if (!videoRef.current) return
    if (isPlaying) {
      videoRef.current.pause()
      setIsPlaying(false)
    } else {
      videoRef.current.play()
      setIsPlaying(true)
    }
  }

  const toggleMute = (e) => {
    e.stopPropagation()
    if (!videoRef.current) return
    videoRef.current.muted = !isMuted
    setIsMuted(!isMuted)
  }

  const handleTimeUpdate = () => {
    if (!videoRef.current) return
    const current = videoRef.current.currentTime
    const duration = videoRef.current.duration
    if (duration) {
      setProgress((current / duration) * 100)
    }
  }

  const handleSeek = (e) => {
    e.stopPropagation()
    if (!videoRef.current) return
    const rect = e.currentTarget.getBoundingClientRect()
    const pos = (e.clientX - rect.left) / rect.width
    videoRef.current.currentTime = pos * videoRef.current.duration
  }
  return (
    <div className="relative group rounded-xl md:rounded-xl overflow-hidden border border-slate-200/80 bg-[#000036] shadow-2xl aspect-video w-full">
      <video
        ref={videoRef}
        src={src}
        poster={poster}
        className="w-full h-full object-cover cursor-pointer"
        loop
        muted={isMuted}
        playsInline
        onTimeUpdate={handleTimeUpdate}
        onClick={togglePlay}
      />
      {!isPlaying && (
        <div className="absolute inset-0 flex items-center justify-center bg-black/10  transition-all">
          <button
            onClick={togglePlay}
            aria-label="Play video"
            className="group/btn relative flex items-center justify-center w-16 h-16 md:w-24 md:h-24 rounded-full bg-white text-[#000036] shadow-[0_0_40px_rgba(0,0,0,0.3)] hover:scale-110 active:scale-95 transition-all duration-300"
          > <span className="absolute inset-0 rounded-full bg-white/40 animate-ping" />
            <Play  className="translate-x-0.5 text-2xl md:text-[32px] fill-slate-950" />
          </button>
        </div>
      )}
      {isPlaying && (
        <div className="absolute inset-x-0 bottom-0 p-4 md:p-6 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex flex-col gap-2.5 transition-opacity duration-300 opacity-0 group-hover:opacity-100">
          <div
            onClick={handleSeek}
            className="relative w-full h-1.5 bg-white/30 rounded-full cursor-pointer overflow-hidden"
          >
            <div
              className="h-full bg-violet-500 rounded-full transition-all duration-100"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="flex items-center justify-between text-white">
            <div className="flex items-center gap-2">
              <button
                onClick={togglePlay}
                aria-label={isPlaying ? 'Pause' : 'Play'}
                className="p-2 rounded-full hover:bg-white/20 transition-colors"
              >
                {isPlaying ? (
                  <Pause size={18} className="fill-white" />
                ) : (
                  <Play size={18} className="fill-white" />
                )}
              </button>
              <button
                onClick={toggleMute}
                aria-label={isMuted ? 'Unmute' : 'Mute'}
                className="p-2 rounded-full hover:bg-white/20 transition-colors"
              >
                {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
              </button>
            </div>
            <span className="text-xs font-medium text-white/80 select-none">
              {isPlaying ? 'Playing' : 'Paused'}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}